import React from 'react'
import { NavLink } from 'react-router-dom'
import { Trans } from 'react-i18next'
import Item from 'components/Item/Item'

const WorkEmpty = () => {
    return (
        <Item>
            <div className='d-flex flex-column h-100 justify-content-center text-body-secondary text-center'>
                <div><i className='mdi mdi-file-table-box-multiple-outline mdi-72px'></i></div>
                <h6><Trans i18nKey="works.item.empty.title" /></h6>
                <div><Trans i18nKey="works.item.empty.subtitle" /></div>
                <div className='mt-4'>
                    <NavLink className={'btn bg-primary text-white shadow-sm'} aria-current="page" to={"./new"} end>
                        <i className='mdi mdi-plus-outline me-1'></i>
                        <Trans i18nKey="works.item.empty.button" />
                    </NavLink>
                </div>
            </div>
        </Item>

    )
}

export default WorkEmpty